import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { CheckoutProgressComponent } from '../../checkout/checkout-progress/checkout-progress.component';

@Component({
  selector: 'app-checkout-header',
  templateUrl: './checkout-header.component.html',
  styleUrls: ['./checkout-header.component.scss'],
  imports: [CheckoutProgressComponent],
})
export class CheckoutHeaderComponent implements OnInit, OnDestroy {
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2
  ) {}

  ngOnInit() {
    this.renderer.addClass(this.document.body, 'checkout');
  }

  ngOnDestroy() {
    this.renderer.removeClass(this.document.body, 'checkout');
  }
}
